import UI from "./base/UI";
import {scrollTo} from "../functions/simple.ui";
import {scrollTriggerAnim ,isA11yScrollAnimation} from "../functions/simple.ui";

import { isA11yCheckVersion, isA11ySetAttr } from "../functions/a11y.ui";
/**
 * ScrollAnimation
 */

/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/scroll_animation.html](http://172.20.160.28:9700/kbank_html_mmk/components/scroll_animation.html)
*/
class ScrollAnimation extends UI {
    defaults = {
        topPos : 0,
        auto : true
    };

    constructor(el, options) {
        super('scrollAnimation', el);
        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...this.parseOptions(options)};
        this.topPos = this.$el.offset().top;
        if (this.defaults.auto) { //CHPFMTASK-870  data-auto="false" 일때  처음 진입 실행x    $(선택자).data('ui').render() 실행시 실행
            this.render();
        }
        
    }

    update() {
        this.detachEvents();
        this.attachEvents();
    }

    render() {
        if (!this.$el.closest('.ui-kbank-page-control').hasClass('activeSlide') && this.$el.attr('data-auto-reset') == 'true') {
            return false
        }
        const getScrollParent = (node) => {
            if (node === null) return null; 
            const overflowY = window.getComputedStyle(node).overflowY;
            // console.log(node, overflowY);
            if (node.scrollHeight > node.clientHeight && overflowY !== 'visible' && overflowY !== 'hidden') {
                return node;
            } else if (node.tagName.toLowerCase() === 'body' ) {
                return window;
            } else {
                return getScrollParent(node.parentNode)
            }
            
            // 부모요소 찾는방법 변경 :CHPFMTASK-1848
            // 부모들 저장
            // const getParents = $(node).parents(); 
            // // 리턴 기본값은 윈도우
            // let returnEl = window; 
            // // 부모갯수 만큼 for 돌림
            // for(let key in Array.from(getParents)) {
            //     // 순차적으로 css 오버플로우 값을 가져옴
            //     const checkOverflow = getComputedStyle(getParents[key]).overflowY;
            //     // 오버플로우 값이 하기 두가지 조건에 일치하면 리턴값을 조건에 일치한 요소로 바꿈
            //     if(checkOverflow === 'auto' || checkOverflow === 'scroll') returnEl = getParents[key];
            // }
            
            // console.log(returnEl);
            // return returnEl;
        }
        const _that = this;
        this.animationGroup = this.$el;
        this.animationGroup.find('svg path').each((idx, el) => {
            _that.svgLengthCheck(el);
        });
        
        if (this.$el[0].offsetParent === null) {
            const that = this;
           
            function containerCheck() {
                if(that.$el[0].offsetParent === null) {
                    window.requestAnimationFrame(containerCheck)
                } else {
                    // setTimeOut 삭제 2025.01.14(CHPFMTASK-1848)
                    const scrollableEl = getScrollParent(that.$el[0]);
                    that.scrollTarget = scrollableEl;
                    that.animationActive();
                    that.detachEvents();
                    that.attachEvents();
                }
            }
            window.requestAnimationFrame(containerCheck)
        } else {
            const scrollableEl = getScrollParent(this.$el[0]);
            this.scrollTarget = scrollableEl;
            this.animationActive(); 
            this.detachEvents();
            this.attachEvents();
        }

        /*! s: FETASK-a11y page ScrollAnimation v.1.0.0 */
        const isA11yCheck = isA11yCheckVersion();

        isA11yScrollAnimation(this.$el[0]); // 240620  simple.js 
        /*! e: FETASK-a11y page ScrollAnimation v.1.0.0 */
    }

    svgLengthCheck(el){
        const totalLength = el.getTotalLength();
        $(el).css({
          'stroke-dasharray': totalLength,
          'stroke-dashoffset': totalLength
        });
    } 

    // 기존 애니메이션 
    itemInView(box) {
        const $itemWrap = $(box);
        const activeTiming = 150;

        $itemWrap.find('[data-role="animation-item"]').each((idx, item) => {
            setTimeout(() => {
                if ($(item),$(item).closest('.ui-swiper').length == 0) { //FETASK-877 | 230419 | 스와이퍼 안에 있는 경우 active 클래스 x

                    $(item).addClass('active');
                }
                if ($(item).closest('.feeling-view02').length > 0) { // FETASK-1625 | 기분통장 스크롤시 숫자 카운팅 실행
                    frontUI.calcAnimation();
                }
            }, activeTiming * idx);
        })
    }

    // fade-up 애니메이션
    itemInViewFadeup(box) {
        const $itemWrap = $(box);
        const activeTiming = 150;

        $itemWrap.find('[data-role="animation-item"]').each((idx, item) => {
            setTimeout(() => {
                if ($(item),$(item).closest('.ui-swiper').length == 0) { //FETASK-877 | 230419 | 스와이퍼 안에 있는 경우 active 클래스 x

                    $(item).addClass('active');
                    // ($(item).find('[data-ani-type]')?.length > 0 && $(item).find('[data-ani-type]')?.attr('data-ani-type') === 'up') ? $(item).addClass('active') : $(item).addClass(value ? value : 'active');
                }
                if ($(item).closest('.feeling-view02').length > 0) { // FETASK-1625 | 기분통장 스크롤시 숫자 카운팅 실행
                    frontUI.calcAnimation();
                }
            }, activeTiming * idx);
        })
    }

    animationActive() {
        const getPcscrollgab = this.$el.closest(`div[data-pc-scrollgab]`)[0],
        getMoscrollgab = this.$el.closest(`div[data-mo-scrollgab]`)[0];
        let pcScrollgab = 0, moScrollgab = 0;
        if(getPcscrollgab) pcScrollgab = Number(getPcscrollgab.dataset.pcScrollgab);
        if(getMoscrollgab) moScrollgab = Number(getMoscrollgab.dataset.moScrollgab);
        if (this.scrollTarget === window) {
            if (!this.$el.hasClass('inScroll')) {
                if (this.$el.offset().top <= $(window).scrollTop() + (window.innerHeight * 0.85) - pcScrollgab){ // 231121 : window.innerHeight * 0.7 에서 속도조절
                    // this.$el.addClass('inScroll');
                    // this.itemInView(this.$el[0]);
                    checkOnce(this);
                }
            }
        } else {
            if (!this.$el.hasClass('inScroll')) {
                if ($('html').hasClass('pc')) { // FETASK-1048  | 230622 |  pc화면에 모달팝업인 경우에 (layout-pddetail-pc.html)
                    if (this.$el.offset().top  <= (window.innerHeight - (window.innerHeight / 1.5) + $('html').scrollTop()) - pcScrollgab) {
                        // console.log(11111)
                        // this.$el.addClass('inScroll');
                        // this.itemInView(this.$el[0]);
                        checkOnce(this);
                    }
                } else {
                    // s: FETASK-1471   | 230921 | 세로가 긴 기종일때 첫화면에서 보이게 세팅 
                    let fixedBottomH = 0;
                    if ($(document).find('.fixed-bottom').length > 0) {
                        fixedBottomH = $(document).find('.fixed-bottom').outerHeight(true);
                    }
                    // s: CHPFMTASK-1789   | 250218 | 조금더 하단에서 보이게 세팅
                    if ($(document).find(`[data-item="fast"]`).length > 0) {
                        if (!this.$el.hasClass('inScroll') && this.$el.offset().top < (window.innerHeight - (window.innerHeight / 3)) - fixedBottomH - moScrollgab + 250) {
                            // this.$el.addClass('inScroll');
                            // this.itemInView(this.$el[0]);
                            checkOnce(this);
                        }
                    } else {
                        // console.log('333')
                        //console.log('fixedBottomH',fixedBottomH,'moScrollgab',moScrollgab)
                        // if (!this.$el.hasClass('inScroll') && this.$el.offset().top < window.innerHeight - fixedBottomH - 'moScrollgab') { //CHPFMTASK-1380  240909 임시 수정
                        if (!this.$el.hasClass('inScroll') && this.$el.offset().top < (window.innerHeight - (window.innerHeight / 3)) - fixedBottomH - moScrollgab) {
                            // this.$el.addClass('inScroll');
                            // this.itemInView(this.$el[0]);
                            checkOnce(this);
                        }
                        // e: FETASK-1471   | 230921 | 세로가 긴 기종일때 첫화면에서 보이게 세팅
                        if (!this.$el.hasClass('inScroll') && this.$el.offset().top - $(window).scrollTop() <= (window.innerHeight - (window.innerHeight / 3) - moScrollgab)) { // 230627 | 팝업에서 윈도우 스크롤탑 위치 제외 
                            // if (this.$el.offset().top <= (window.innerHeight - (window.innerHeight / 3))) {
                            // this.$el.addClass('inScroll');
                            // this.itemInView(this.$el[0]);
                            checkOnce(this);
                        }
                    }
                   
                   
                    // e: CHPFMTASK-1789   | 250218 | 조금더 하단에서 보이게 세팅
                }
            }
        }

        function checkOnce(target){
            if(target.$el.closest(`.tab-content`).length > 0) {
                if(target.$el.closest(`.tab-content`).css('display') == 'block'){
                    target.$el.addClass('inScroll');
                    // target.itemInView(target.$el[0]);
                    checkAnimation(target);
                }
            }else{
                target.$el.addClass('inScroll');
                // target.itemInView(target.$el[0]);
                checkAnimation(target);
            }
            if(target.$el.attr('data-once') != undefined){
                target.$el.find('[data-ani-type="up"], [data-ani-type="fade-up"]')?.off('animationend').on('animationend',()=>{
                    target.$el.attr('data-auto','false');
                });
            }
        }

        function checkAnimation(target){
            (target.$el.find('[data-ani-type="fade-up"]').length) ? target.itemInViewFadeup(target.$el[0]) : target.itemInView(target.$el[0]);
        }
    }

    attachEvents() {
        $(this.scrollTarget).on(`scroll${this.eventId}`, (e) => {
            // console.log($(this.scrollTarget))
            this.animationActive();
        });
    }

    detachEvents() {
        $(this.scrollTarget).off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }
    /**
    * [data-role="animation-group"]  자식 요소의 inScroll class,  [data-role="animation-item"]의 모든 active class remove Event 
    * @example 
    * $('[data-role="animation-group"]').data('ui').resetClass();
    */
    resetClass() {
        this.$el.removeClass('inScroll')
        this.$el.find('[data-role="animation-item"]').each((idx, item) => {
            $(item).removeClass('active')
        })
    }

    /*! s: FETASK-a11y page ScrollAnimation v.1.0.0 */
    // isA11yScrollAnimation(){
    //     // 관리자 페이지 svg 접근성 대응 data-role="animation-item"
    //     const svgEles = this.$el[0]?.querySelectorAll('svg');

    //     svgEles && isA11ySetAttr(svgEles, 'aria-hidden' , 'true');
    //     svgEles && isA11ySetAttr(svgEles, 'tabindex' , '-1');
    //     console.log(111,$(svgEles)?.find('*'))
    //     $(svgEles)?.find('*').attr({'aria-hidden':'true', 'tabindex':'-1'});
    // }
    /*! e: FETASK-a11y page ScrollAnimation v.1.0.0 */
}

export default ScrollAnimation;
